module.exports = __webpack_public_path__ + "static/media/ios-albums.a374f8b0.svg";